/**
 * Shared BlockNote editor styles
 * Centralized styles for consistent editor appearance across the application
 */

export const customBlockNoteStyles = `
  /* Remove default padding and add our own */
  .bn-container {
    padding: 0 !important;
    border-radius: 0.75rem !important;
    overflow: hidden !important;
  }

  /* Reset any border styles that might be interfering */
  .bn-container, .bn-editor-content, .bn-editor {
    border: none !important;
  }

  /* Add proper padding to the editor content instead */
  .bn-editor-content {
    padding: 0 !important;
  }

  .bn-editor {
    padding-inline: 2rem !important;
  }

  /* Make inline content fill full width for proper cursor placement */
  .bn-inline-content {
    width: 100%;
  }

  /* Remove any backgrounds that might be interfering */
  .bn-container, .bn-editor, .bn-editor-content {
    background: transparent !important;
  }
`;

/**
 * Injects the shared BlockNote styles into the document head
 * @param styleId Unique identifier for the style element (to avoid duplicates)
 * @returns Cleanup function to remove the styles
 */
export const injectBlockNoteStyles = (
  styleId: string = 'blocknote-shared-styles',
): (() => void) => {
  // Check if styles already exist
  const existingStyle = document.getElementById(styleId);
  if (existingStyle) {
    // Return a no-op cleanup function since styles already exist
    return () => {};
  }

  // Add custom styles to head
  const styleElement = document.createElement('style');
  styleElement.id = styleId;
  styleElement.innerHTML = customBlockNoteStyles;
  document.head.appendChild(styleElement);

  // Return cleanup function
  return () => {
    const style = document.getElementById(styleId);
    if (style) {
      document.head.removeChild(style);
    }
  };
};
